import React from 'react';
import Environment from '@config/index';
import styles from '@components/molecules/products/product-details/components/product-installment/modal-payment-installment/modal-payment-installment.module.scss';

const FacilipayOney = () => (
  <div className={styles.faciliPayOney_Cotainer}>
    <img
      src={`${Environment.cdnFolder}/assets/images/cart/facilipay-oney-popin.svg`}
      width="100%"
      height="100%"
      alt="Oney paiement par carte bancaire"
    />

    <div
      id="desc"
      className="visuallyhidden"
    >
      <h3>Oney paiement par carte bancaire</h3>

      <p>Choisissez fois trois ou fois quatre lorsque vous sélectionnez votre mode de paiement.</p>

      <p>Dites nous tout. Facile et rapide, complétez le formulaire sans fournir aucun document.</p>

      <p>Et voilà ! Vous avez une réponse immédiate.</p>

      <p>
        Offre de ﬁnancement sans assurance avec apport obligatoire, réservée aux particuliers et valable pour tout achat
        de 300€ à 6 000€. Sous réserve d’acceptation par Oney Bank. Vous disposez d’un délai de 14 jours pour renoncer à
        votre crédit. Exemple en 3 fois pour un achat de 150€, apport de 52,18€, puis 2 x 50€. Crédit sur 2 mois au TAEG
        ﬁxe de 19,31%. Coût du ﬁnancement 2,18€ dans la limite de 15€. Exemple en 4 fois pour un achat de 400€, apport
        de 108,80€, puis 3 mensualités de 100€. Crédit sur 3 mois au TAEG fixe de 19,61%. Coût du financement 8,80€,
        dans la limite de 30€ maximum. Oney Bank - SA au capital de 51 286 585€ - 34 Avenue de Flandre 59 170 Croix -
        546 380 197 RCS Lille Métropole - n° Orias 07 023 261 www.orias.fr - Correspondance : CS 60 006 - 59895 Lille
        Cedex - www.oney.fr
      </p>
    </div>
  </div>
);

export default FacilipayOney;
